import styled from "styled-components";

export const Spacer = styled.span<{ width: number }>`
  display: inline-block;
  width: ${(props) => `${props.width}px`};
`;
